module.exports = __webpack_public_path__ + "static/img/E3200.ff3230f3.jpg";